import { graphql, useStaticQuery } from "gatsby"
import React, { useState } from "react"
import "twin.macro"
import {
  GatsbyImage,
  getImage,
  IGatsbyImageData,
  ImageDataLike,
} from "gatsby-plugin-image"
import tw from "twin.macro"

type dataType = {
  allGalleryJson: {
    nodes: {
      graphic: boolean
      branding: boolean
      photography: boolean
      image: ImageDataLike
    }[]
  }
}
const DesignSample = () => {
  const data: dataType = useStaticQuery(graphql`
    query MyQuery {
      allGalleryJson {
        nodes {
          graphic
          branding
          photography
          image {
            childImageSharp {
              gatsbyImageData(placeholder: BLURRED)
            }
          }
        }
      }
    }
  `)
  const allData = data.allGalleryJson.nodes
  const photophaphData = data.allGalleryJson.nodes.filter(
    arr => arr.photography === true
  )
  const brandData = data.allGalleryJson.nodes.filter(
    arr => arr.branding === true
  )
  const graphicData = data.allGalleryJson.nodes.filter(
    arr => arr.graphic === true
  )

  const [designData, setDesignData] = useState(allData)
  const DesignData = [
    {
      onClick: () => setDesignData(allData),
      title: "ALL",
      data: allData,
    },
    {
      onClick: () => setDesignData(brandData),
      title: "BRANDING",
      data: brandData,
    },
    {
      onClick: () => setDesignData(graphicData),
      title: "GRAPHIC DESIGN",
      data: graphicData,
    },
    {
      onClick: () => setDesignData(photophaphData),
      title: "PHOTOGRAPHY",
      data: photophaphData,
    },
  ]
  return (
    <div tw=" min-h-screen max-w-5xl mx-auto mt-24 p-5 pb-0" id="DESIGNSAMPLE">
      <div tw="flex flex-col items-center justify-center space-y-8 min-h-screen mx-auto mb-48">
        <div tw="text-4xl text-size-adjust[inherit] font-bold">
          <p> We're making design better for everyone </p>
        </div>
        <div tw="text-xl   max-w-3xl font-extralight  md:ml-20 ">
          <p>
            Aliquam a augue suscipit, luctus neque purus ipsum neque dolor
            primis libero tempus,tempor posuere ligula varius augue luctus don
            messi nymr usnaldo{" "}
          </p>
        </div>
        <div tw="grid md:grid-cols-4 ">
          {DesignData.map((item, index) => (
            <div key={index}>
              <button
                onClick={item.onClick}
                tw="focus:outline-none pr-4 pl-4 rounded-full py-3 px-6 font-bold hover:(background-color[maroon] text-white)"
              >
                {item.title}
              </button>
            </div>
          ))}
        </div>
        <div tw="grid md:grid-cols-3 gap-4">
          {designData.map((item, index) => {
            const image = getImage(item.image)
            return (
              <div key={index}>
                <div
                  className="group"
                  tw="relative transform hover:scale-105
                   transition-all motion-reduce:transform-none"
                >
                  <GatsbyImage image={image as IGatsbyImageData} alt="pic" />

                  <div tw="opacity-0 p-20 text-white  z-10 top-0 left-0 absolute w-full h-full  bg-opacity-30 group-hover:(opacity-100) "></div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default DesignSample
